// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderLinkGroup__root--2SiZb"};